import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Leftside from "../Landing_page/Left_sidebar/Leftside";
import Articlepage from "../Landing_page/Main_page/Article/Articlepage";
import Myfeed from "../Landing_page/Main_page/Myfeed/Myfeed";
import Rightside from "../Landing_page/Right_sidebar/Rightside";
import { PostCard } from "./PostCard";
import { ProfileSmallComp } from "./ProfileSmallComp";
import styles from "./profile.module.css";
import { v4 as uuid } from 'uuid';
import { Spinner } from "./Spinner";

export const Temp = () => {
    const [feedPosts, setFeedPosts] = useState([])
    const [suggestions, setSuggestions] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(false);
    const loggedInUser = useSelector(state => state.loggedInUser);
    const url = process.env.REACT_APP_url;

    useEffect(() => {
        // console.log(loggedInUser.username);
        setIsLoading(true);
        axios.get(`${url}/posts/feed/${loggedInUser.username}`)
            .then((res) => {
                // console.log(res.data);
                if (res.data.posts.length === 0) {
                    setShow(true);
                } else {
                    setShow(false);
                }
                setFeedPosts(res.data.posts);
            })
            .catch((err) => {
                alert(err);
            })
            .finally(() => {
                setIsLoading(false);
            })
        axios.get(`${url}/users/suggestions/${loggedInUser._id}`)
            .then((res) => {
                setSuggestions(res.data.suggestions);
            })
            .catch((err) => {
                alert(err);
            })
    }, [])
    return (
        <div>
            {isLoading ? <Spinner /> : (
                <div style={{ display: "flex", paddingTop: "15px", maxWidth: "100%", justifyContent: "space-between", backgroundColor: "rgb(245,247,250)", overflowY: "hidden" }}>
                    <Leftside />
                    <div style={{ minWidth: "230px" }}></div>
                    <div style={{ display: "flex", width: "50%", flexDirection: "column", backgroundColor: "rgb(245,247,250)" }}>
                        <Articlepage />
                        <div className={styles.suggestionsDiv}>
                            {suggestions?.map((item) => (
                                <ProfileSmallComp key={uuid()} item={item} />
                            ))}
                        </div>
                        <Myfeed />
                        {show ? <h3 style={{ color: "grey", padding: "30px 3px", textAlign: "center" }}>No posts to show. Follow people to see their posts.</h3> : null}
                        <PostCard posts={feedPosts} />
                    </div>
                    <Rightside style={{ border: "2px solid red" }} />
                </div>
            )}
        </div>
    )
}